export const isIE9 = () => {
    var b = document.createElement('b')
    b.innerHTML = '<!--[if IE 9]><i></i><![endif]-->'
    return b.getElementsByTagName('i').length === 1
}

export const isPc = () => {
    var userAgentInfo = navigator.userAgent;
    var Agents = ["Android", "iPhone",
            "SymbianOS", "Windows Phone",
            "iPad", "iPod"];
    var flag = true;
    for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
        }
    }
    return flag;
}

// 升级邮箱
export function linkToUpdate(uid) {
	const e = uid.split("@")[1].match(/\d+/)[0] + ".com", linkMap = {
		"163.com": "https://reg.vip.163.com/changeMailType2.m",
		"126.com": "https://reg.vip.126.com/checkUpgradeState2.m?from=wel",
		"188.com": "https://reg.mail.188.com/servlet/vipupgrade/index2"
	}
	window.open(linkMap[e])
}

// 15元以下套餐
export function isIt15(mailType) {
	if (!mailType) {
		return true;
	}
	return [ 'v18', 'v33' ].indexOf(mailType) >= 0;
}

export function isFreeMail(mailType) {
	if (!mailType) {
		return true;
	}
	return 'free' === mailType;
}

export function redirectToLogin() {
    if (!isPc()) {
        let url = encodeURI('https://vip.163.com/activity/200618/wap.html');
        window.location.href = `https://dl.reg.163.com/ydzj/maildl?product=vipactivty&curl=${url}`;
    }
}

// 移动端支付
export function wapPay() {
	window.location.href = "https://vpay.vip.163.com/center/webapp.html?from=200618&besource=vip_2020618_xf";
}

export function getQueryString(e) {
	var t = new RegExp("(^|&)" + e + "=([^&]*)(&|$)", "i");
	var paramStr = window.location.search;
	var n = paramStr.substr(1).match(t);
	var rgExp = /(\>|\<|\'|\\|\\\\)/ig;

	if (n != null && !rgExp.test(n[2])) {
		return unescape(n[2]);
	}
	return "";
}